import { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalCloseButton, ModalFooter, ModalHeader } from '@panwds/react-ui'
import events from '../../framework/events'
import { _T } from '../../i18n'
import type { ReactElement, CSSProperties } from 'react'

const SWITCH_TSG_FAILED_EVENT = 'switch-tsg-failed'
const useTsgErrorModal = () => {
  const [tsgErrModal, setTsgErrModal] = useState<ReactElement>()
  useEffect(() => {
    const tsgSwitcherErrHandler = ({ error }: { error: Error }) => {
      const modal = <Modal
        key={'tsg-error'}
        isOpen={true}
        onClose={() => setTsgErrModal(undefined)}
        size={'md'}
        style={{ // vertial center
          minHeight: 50,
        } as CSSProperties}
      >
        <ModalHeader title={_T('Error')} />
        <ModalBody>{error.message}<br />{_T('Please try refresh the browser or sign-in again.')}</ModalBody>
        <ModalFooter>
          <ModalCloseButton>{_T('Close')}</ModalCloseButton>
        </ModalFooter>
      </Modal>
      setTsgErrModal(modal)
    }
    events.on(SWITCH_TSG_FAILED_EVENT, tsgSwitcherErrHandler)
    return () => {
      events.off(SWITCH_TSG_FAILED_EVENT, tsgSwitcherErrHandler)
    }
  }, [])

  return tsgErrModal
}

export default useTsgErrorModal
